import { useState } from "react";
import { toast } from "react-toastify";

import ConfirmModal from "../../Components/Shared/ModalCustom/ConfirmModal";
import { idColumn, nameColumn, textColumn } from "../../Components/Shared/TableColumns/tableColumns";
import { useApiData } from "../../Hooks/useApiData";
import { deleteRole, getRoles } from "../../Service/RolService/RolService";
import { getPermissions } from "../../Service/PermissionService/PermissionService";
import { apiErrorStatus, handleApiError } from "../../Utils/apiErrors";
import RoleFormModal from "./RoleFormModal";
import SearchableTable from "./SearchableTable";
import { UsersTabProps } from "./userUtils";

// Pestaña Roles: listado (GET /rol), alta/edición con sus permisos y borrado
export default function RolesTab(props: UsersTabProps) {
  const { selfRolId, createOpen, onCreateClose, onSelfChanged } = props;

  const { data: roles, loading, reload } = useApiData<any[]>(getRoles);
  const { data: permissions } = useApiData<any[]>(getPermissions);

  const [editing, setEditing] = useState<any>(null);
  const [toDelete, setToDelete] = useState<any>(null);
  const [deleting, setDeleting] = useState(false);

  const usersCount = Number(toDelete?.employees_count ?? 0);

  const remove = () => {
    setDeleting(true);
    deleteRole(toDelete.id)
      .then(() => {
        toast.success("Rol eliminado");
        setToDelete(null);
        reload();
      })
      .catch((error) => {
        // 409: tiene usuarios asignados; el back indica cuántos
        handleApiError(error, { fallback: "No se ha podido eliminar el rol", onNotFound: reload });
        if (apiErrorStatus(error) === 404) setToDelete(null);
      })
      .finally(() => setDeleting(false));
  };

  const columns = [
    idColumn(),
    nameColumn("name", "Rol"),
    textColumn("employees_count", "Usuarios"),
    textColumn("permissions_count", "Permisos"),
  ];

  return (
    <>
      <SearchableTable
        rows={roles}
        columns={columns}
        loading={loading}
        onEdit={setEditing}
        onDelete={setToDelete}
      />

      {createOpen || editing ? (
        <RoleFormModal
          roleId={editing?.id ?? null}
          permissions={permissions}
          isSelfRole={editing !== null && editing.id === selfRolId}
          onClose={() => {
            setEditing(null);
            onCreateClose();
          }}
          onChanged={() => {
            reload();
            if (editing?.id === selfRolId) onSelfChanged();
          }}
        />
      ) : null}

      <ConfirmModal
        show={toDelete !== null}
        title="Eliminar rol"
        message={
          usersCount > 0
            ? `El rol "${toDelete?.name}" tiene ${usersCount} ${usersCount === 1 ? "usuario asignado" : "usuarios asignados"}. Asígnales otro rol antes de eliminarlo.`
            : `¿Quieres eliminar el rol "${toDelete?.name}"? Esta acción no se puede deshacer.`
        }
        confirmLabel="Eliminar"
        onConfirm={remove}
        onCancel={() => setToDelete(null)}
        disabled={deleting || usersCount > 0}
      />
    </>
  );
}
